import StructureGridHtml from "./StructureGridHtml.js";
import {assertNotNull} from "../../js/util/CommonUtils.js";

export default class StructureGridCmp {
    #html = new StructureGridHtml();

    /** @param {HTMLElement} parent */
    init(parent) {
        // remove previous cards
        parent.innerHTML = '';
        this.#html.init(parent);
    }

    /**
     * @param {StructureId} structureId
     * @param {StructureForms} forms
     */
    addStructure(structureId, forms) {
        this.#html.addCard(structureId, assertNotNull(forms));
    }

    /**
     * @param {StructureId} structureId
     * @param {StructureForms} forms
     */
    updateStructure(structureId, forms) {
        this.#html.updateCard(structureId, assertNotNull(forms));
    }

    /** @param cb */
    onDeleteClicked(cb){
        this.#html.onDelete(cb)
    }

    /**
     * @returns {HTMLElement}
     */
    addLastCard() {
        return this.#html.addLastCard();
    }
    onCardTitleClicked(cb) {
        this.#html.onCardTitleClicked(cb);
    }
}